module.exports = __webpack_public_path__ + "static/media/partner-icon-nftcdn-greyscale.7fcb04b8.svg";